import React from 'react'
import { injectIntl } from 'react-intl'

import './Error.css'

export default injectIntl(({ intl, technicalError, kind }) => {
  const errorKind =
    technicalError !== undefined && technicalError === 'noKind'
      ? 'noKind'
      : technicalError !== undefined ? 'tech' : kind
  return (
    <div className="cm-error">
      <span className="cm-error--title">
        {intl.messages.errors[errorKind].title}
      </span>
      <span className="cm-error--detail">
        {intl.messages.errors[errorKind].detail}
      </span>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/Error.js